import { TableVariantType } from './variants';
export const getTableStyles = (FOUNDATIONS, FONT) => {
    return {
        [TableVariantType.DEFAULT]: {
            wrapper: {
                width: '100%',
                position: 'relative',
            },
            scrollableContainer: {
                width: '100%',
                overflow: 'auto',
            },
            leftBoxShadowContainer: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                width: FOUNDATIONS.size_100,
                pointer_events: 'none',
                transition: 'box-shadow 200ms',
            },
            rightBoxShadowContainer: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                width: FOUNDATIONS.size_100,
                pointer_events: 'none',
                transition: 'box-shadow 200ms',
            },
            container: {
                display: 'table',
                width: '100%',
            },
            headBoxShadow: `0rem ${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_100} -${FOUNDATIONS.spacing_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`,
            leftBoxShadow: `${FOUNDATIONS.color_effect_shadow_inner_50} ${FOUNDATIONS.spacing_125} -${FOUNDATIONS.spacing_25} ${FOUNDATIONS.spacing_100} -${FOUNDATIONS.spacing_50} inset`,
            rightBoxShadow: `${FOUNDATIONS.color_effect_shadow_drop_75} -${FOUNDATIONS.spacing_125} -${FOUNDATIONS.spacing_25} ${FOUNDATIONS.spacing_100} -${FOUNDATIONS.spacing_50} inset`,
        },
    };
};
//# sourceMappingURL=styles.js.map